"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _VideoButton = _interopRequireDefault(require("./VideoButton"));

var _HamburgerIconTheater = _interopRequireDefault(require("./HamburgerIconTheater.js"));

var _ResponsivePlayer = _interopRequireDefault(require("../ResponsivePlayer.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var classNames = require("classnames");
/* Due to various restrictions, ReactPlayer is not guaranteed to function properly on mobile devices. The YouTube player 
documentation, for example, explains that certain mobile browsers require user interaction before playing: */


var Video = function Video(props) {
  var sidebarClass = classNames({
    theater: true,
    "theater--closed": !props.isOpen,
    "theater--open": props.isOpen,
    "theater--closing": props.isClosing
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: sidebarClass
  }, props.isOpen && !props.isOpening && /*#__PURE__*/_react["default"].createElement("div", {
    className: "theater-content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "columns"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "column is-2"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "column"
  }, /*#__PURE__*/_react["default"].createElement(_ResponsivePlayer["default"], {
    url: props.videoUrl,
    controls: props.controls,
    playing: props.playing && !props.isClosing && !props.isOpening
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "column is-2"
  }))));
};

Video.propTypes = {
  isOpen: _propTypes["default"].bool,
  isOpening: _propTypes["default"].bool,
  isClosing: _propTypes["default"].bool,
  videoUrl: _propTypes["default"].string,
  controls: _propTypes["default"].bool,
  playing: _propTypes["default"].bool
};
var _default = Video;
exports["default"] = _default;

//# sourceMappingURL=Video.js.map